// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"dacb8f5d","161":"6a0df95a","180":"997d08fe","331":"d80cc869","338":"8f3d7ee1","510":"68066412","606":"3f0faff3","677":"0f69c8b0"}[chunkId] + ".chunk.js";
};